import { LoadingButton } from "@mui/lab";
import { ReactNode } from "react";

interface SecondaryButtonProps {
  label: string;
  onClickAction?: any;
  isLoading?: boolean;
  icon?: ReactNode;
  isDisabled?: boolean;
}

export const SecondaryButton = (props: SecondaryButtonProps) => {
  return (
    <LoadingButton
      variant="outlined"
      disableElevation
      sx={{ textTransform: "none" }}
      startIcon={props.icon}
      loading={props.isLoading}
      loadingPosition="start"
      fullWidth
      onClick={props.onClickAction}
      disabled={props.isDisabled}
    >
      {props.label}
    </LoadingButton>
  );
};
